import { Icon, IconProps } from "../";

export const MoreHorizIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.5C5.175 10.5 4.5 11.175 4.5 12C4.5 12.825 5.175 13.5 6 13.5C6.825 13.5 7.5 12.825 7.5 12C7.5 11.175 6.825 10.5 6 10.5ZM18 10.5C17.175 10.5 16.5 11.175 16.5 12C16.5 12.825 17.175 13.5 18 13.5C18.825 13.5 19.5 12.825 19.5 12C19.5 11.175 18.825 10.5 18 10.5ZM10.5 12C10.5 11.175 11.175 10.5 12 10.5C12.825 10.5 13.5 11.175 13.5 12C13.5 12.825 12.825 13.5 12 13.5C11.175 13.5 10.5 12.825 10.5 12Z"
      />
    </Icon>
  );
};
